export const fallbackLng = 'en';
export const languages = [
  fallbackLng,
  'he',
  'ru',
  'zh',
  'fr',
  'es',
  'pt-BR',
  'de',
  'it',
  'ja',
  'ko',
  'ar',
  'tr',
  'vi',
];

/** Mapeia códigos i18next para locales suportados pelo dayjs. */
export function toDayjsLocale(language: string): string {
  if (language === 'pt-BR') return 'pt-br';
  return language.split('-')[0];
}

/** Nome exibido no seletor de idioma (quando Intl não basta). */
export const languageDisplayNames: Record<string, string> = {
  'pt-BR': 'Português (Brasil)',
};

export const defaultNS = 'translation';
export const cookieName = 'i18next';
export const headerName = 'x-i18next-current-language';
